// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1582517a","821":"b1c2c580"}[chunkId] + ".chunk.js";
};